import DownloadTableButton from 'shared/common/DownloadTableButton/ui'
import { useFilter } from 'shared/common/OpenFiltersButton/hooks/useFilter'
import OpenFiltersButton from 'shared/common/OpenFiltersButton/ui'
import { disableFutureDates } from 'shared/helpers/disableFutureDates'
import { Icon } from 'shared/iconpack'
import { expandedSegmentedDateRangeOptions } from 'shared/model/commonConstants'
import { ParamKey } from 'shared/types/QueryModel'

import { ReactNode } from 'react'

import FilterRangePicker from 'shared/ui/FormQuery/FilterRangePicker'
import SearchInput from 'shared/ui/SearchInput'
import SegmentedFilter from 'shared/ui/SegmentedFilter'

import { palette } from 'shared/config/styles/palette'

import './HeaderWithFilters.css'

export interface HeaderWithFiltersProps {
  filters?: ReactNode
  filtersKeys?: ParamKey[]
  tableCount?: number
  withSearchInput?: boolean
  withRangeDate?: boolean
  placeholder?: string
  params: ParamKey[]
  downloadLink?: string
}

const HeaderWithFilters = ({
  filters,
  tableCount,
  withSearchInput = true,
  filtersKeys,
  placeholder,
  withRangeDate = true,
  params,
  downloadLink,
}: HeaderWithFiltersProps) => {
  const { isOpen } = useFilter()

  return (
    <div className="max-w-[1240px] flex flex-col gap-[16px] py-[16px] px-[24px]">
      <div className="flex gap-[12px]">
        {withSearchInput && (
          <SearchInput
            withPage={true}
            placeholder={`${placeholder}`}
            className="w-full max-w-[861px] max-h-[36px] px-[6px] py-[8px] border border-light_gray_7 rounded-[12px]"
          />
        )}
        {withRangeDate && (
          <>
            <SegmentedFilter
              withPage={true}
              options={expandedSegmentedDateRangeOptions}
              className="max-w-[397px]"
            />
            <FilterRangePicker
              withPage={true}
              prefix={
                <Icon
                  name="calendar"
                  width={20}
                  height={18}
                  color={palette.dark}
                />
              }
              disabledDate={disableFutureDates}
              suffixIcon={null}
              placeholder={['Период', 'Период']}
              className="min-w-[260px] text-dark bg-light_gray_3"
            />
          </>
        )}
        {filters && filtersKeys && <OpenFiltersButton filters={filtersKeys} />}
        {downloadLink && (
          <DownloadTableButton
            apiUrl={downloadLink}
            params={params}
          />
        )}
      </div>
      {isOpen && (
        <div className="filtersWrapper w-full flex gap-3">{filters}</div>
      )}
      <span className="font-bold leading-[28px] text-[20px] text-dark">
        Записи: {tableCount}
      </span>
    </div>
  )
}

export default HeaderWithFilters
